import React, { useState, useEffect, /*useMemo,*/ useRef } from 'react'
import { Col, Row, Input, Select, /*Radio,*/ Checkbox, Tooltip } from "antd";
import { /*notifysuccess,*/ notifyfailure, notifycatch } from "../../utils/toast";
import * as XLSX from "xlsx";
// import pptIcon from '../../assets/images/icons/ppt.svg';
import uploadIcon from '../../assets/images/icons/upload-cloud.svg';
import loaderIcon from "../../assets/images/login-and-signup/loader.gif";
import HealthCenterIcon from '../../assets/newlayout/health_center_icon.svg';
import deleteIcon from '../../assets/images/icons/trash.svg';
import backButton from '../../assets/images/back_button_arrow.svg';
import { Link } from "react-router-dom";
// import DateRangePicker from 'react-bootstrap-daterangepicker';
// import moment from "moment";
import XLSXIcon from '../../assets/newlayout/xlsx_icon.svg';
import axios from "axios";
import configData from "../../config/config.json";
import Cookies from "js-cookie";
import searchIcon from '../../assets/images/icons/search.svg';
import { jwtDecode } from "jwt-decode";


const { Option } = Select;

const CreateNewTask = ({ handlePageViewChange }) => {


    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            return () => {
                input.removeEventListener('input', handleInput);
            };
        });

        // Hide placeholder when dropdown is open
        const selectors = document.querySelectorAll('.ant-select');
        const observer = new MutationObserver(() => {
            selectors.forEach(selector => {
                const placeholder = selector.querySelector('.ant-select-selection-placeholder');
                if (!placeholder) return;
                if (selector.classList.contains('ant-select-open')) {
                    placeholder.style.visibility = 'hidden';
                } else {
                    placeholder.style.visibility = '';
                }
            });
        });

        observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class'] });

        return () => observer.disconnect();
    });


    const [buttonProcessing, setButtonProcessing] = useState(false);

    const [name, setName] = useState("");
    const [nameIsRequiredError, setNameIsRequiredError] = useState(false);

    function onChangeName(event) {
        setNameIsRequiredError(false);
        setName(event.target.value);
    }

    function onBlurName(event) {
        if (event.target.value.trim().length === 0) {
            setNameIsRequiredError(true);
        }
        setName(event.target.value.trim());
    }

    const [platform, setPlatform] = useState("adkernel");
    const [platformOptions] = useState([
        { value: 'adkernel', label: 'Adkernel' },
        { value: 'publica', label: 'Publica' }]);


    const [publisherList, setPublisherList] = useState(undefined);
    const [publisherListOptions, setPublisherListOptions] = useState([]);
    const [publisherIsRequiredError, setPublisherIsRequiredError] = useState(false);

    useEffect(() => {
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + "zone/pubFilterList", {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    }
                },)
                .then(res => {
                    setPublisherListOptions(res.data.data);
                })
                .catch(() => { });
        }

    }, [])

    function onChangePublisher(event) {
        setPublisherList(event);
        setPublisherIsRequiredError(false);

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + `zone/pubZoneList?publisherId=${event?.split("-")[0]}&invent_type=${traffic === "website" ? "Website" : traffic === "inapp" ? "Inapp" : "CTV"}`, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    }
                },)
                .then(res => {
                    setZoneListOptions(res.data.data.zone)
                    setZoneList([])
                    setZoneIsRequiredError(false);
                })
                .catch(() => {

                    setZoneListOptions([])
                    setZoneList([])
                    setZoneIsRequiredError(false);
                });
        }
    }

    const [zoneList, setZoneList] = useState([]);
    const [zoneListOptions, setZoneListOptions] = useState([]);
    const [zoneIsRequiredError, setZoneIsRequiredError] = useState(false);

    const [searchZoneList, setSearchZoneList] = useState('');

    const handleSearchZoneList = (e) => {
        setSearchZoneList(e.target.value);
    };

    const filterZoneList = zoneListOptions?.filter(option =>
        option.label.toLowerCase()?.includes(searchZoneList.toLowerCase())
    );

    function handleSelectAllZoneList() {
        const allValues = zoneListOptions.map(option => option.value);
        let tempZoneList = [];
        if (zoneList?.length !== zoneListOptions?.length) {
            tempZoneList = [...allValues];
            setZoneIsRequiredError(false);
        } else {
            tempZoneList = [];
            setZoneIsRequiredError(true);
        }
        setZoneList(tempZoneList);
    }

    function handleZoneList(value) {
        let tempZoneList = [...zoneList]
        let newValue = [];
        if (tempZoneList?.includes(value)) {
            newValue = tempZoneList.filter((item) => item !== value);
        } else {
            newValue = [...tempZoneList, value];
        }
        tempZoneList = newValue
        setZoneList(tempZoneList)
        if (tempZoneList.length > 0) {
            setZoneIsRequiredError(false);
        }
        else {
            setZoneIsRequiredError(true);
        }
    }

    const [openSelectState, setOpenSelectState] = useState({});
    const toggleSelectOpen = (key, open) => {
        setOpenSelectState((prevState) => {
            if (prevState[key] === open) return prevState; // Avoid unnecessary updates
            return { ...prevState, [key]: open };
        });
        if (open) {
            setTimeout(() => {
                refsMap.current[key]?.current?.focus();
            }, 500);
        }
    };

    const refsMap = useRef({});
    function getRef(key) {
        if (!refsMap.current[key]) {
            refsMap.current[key] = React.createRef();
        }
        return refsMap.current[key];
    }

    const [traffic, setTraffic] = useState("website");
    const [trafficOptions] = useState([
        { value: 'ctv', label: 'CTV' },
        { value: 'inapp', label: 'Inapp' },
        { value: 'website', label: 'Website' },
    ]);

    function handleTrafficType(event) {
        setTraffic(event)

        if (publisherList !== undefined) {


            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
                let token = Cookies.get("token_xapads_ssp");
                axios
                    .get(configData.SERVER_URL + `zone/pubZoneList?publisherId=${publisherList?.split("-")[0]}&invent_type=${event === "website" ? "Website" : event === "inapp" ? "Inapp" : "CTV"}`, {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        }
                    },)
                    .then(res => {
                        setZoneListOptions(res.data.data.zone)
                        setZoneList([])
                        setZoneIsRequiredError(false);
                    })
                    .catch(() => {

                        setZoneListOptions([])
                        setZoneList([])
                        setZoneIsRequiredError(false);
                    });
            }

        }


    }


    // const [dataIngestionMethod, setDataIngestionMethod] = useState("upload"); // unused

    // File upload state
    const [uploadedFile, setUploadedFile] = useState(null);
    const [fileError, setFileError] = useState("");
    const [fileIsRequiredError, setFileIsRequiredError] = useState(false);
    const fileInputRef = useRef(null);

    function validateAndSetFile(file) {
        const allowedTypes = [
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];
        const allowedExts = [".xls", ".xlsx"];
        const fileName = file.name.toLowerCase();
        const hasValidExt = allowedExts.some(ext => fileName.endsWith(ext));
        if (!hasValidExt || !allowedTypes.includes(file.type)) {
            setFileError("Only Excel files (.xls, .xlsx) are allowed.");
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array", sheetRows: 10002 });
            const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
            const rows = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
            // Subtract 1 for header row
            const dataRows = rows.length > 0 ? rows.length - 1 : 0;
            if (dataRows > 10000) {
                notifyfailure("Excel file exceeds the maximum allowed limit of 10,000 rows.");
                setFileError("Excel file exceeds the maximum allowed limit of 10,000 rows.");
                if (fileInputRef.current) fileInputRef.current.value = "";
                return;
            }
            setFileError("");
            setFileIsRequiredError(false);
            setUploadedFile(file);
            if (fileInputRef.current) fileInputRef.current.value = "";
        };
        reader.readAsArrayBuffer(file);
    }

    useEffect(() => {
        const input = fileInputRef.current;
        if (!input) return;
        const handleCancel = () => {
            if (!uploadedFile) setFileIsRequiredError(true);
        };
        input.addEventListener('cancel', handleCancel);
        return () => input.removeEventListener('cancel', handleCancel);
    }, [uploadedFile]);

    function handleFileChange(e) {
        const file = e.target.files[0];
        if (!file) return;
        setFileError("");
        setFileIsRequiredError(false);
        validateAndSetFile(file);
    }

    function handleFileDrop(e) {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (!file) return;
        setFileError("");
        validateAndSetFile(file);
    }

    // Number of samples state
    // const [numSamples, setNumSamples] = useState(""); // unused
    // const [numSamplesError, setNumSamplesError] = useState(""); // unused

    // function onChangeNumSamples(e) { ... } // unused
    // function onBlurNumSamples() { ... } // unused

    // Sampling time state
    // const samplingTimeOptions = [...]; // unused
    // const [samplingTime, setSamplingTime] = useState(10); // unused

    const errorDetect = () => {
        let isValid = true;

        if (name.trim() === "") {
            setNameIsRequiredError(true);
            isValid = false;
        }
        if (!publisherList) {
            setPublisherIsRequiredError(true);
            isValid = false;
        }
        if (zoneList.length === 0) {
            setZoneIsRequiredError(true);
            isValid = false;
        }

        if (!uploadedFile) {
            // if (dataIngestionMethod === "upload" && !uploadedFile) {
            setFileIsRequiredError(true);
            isValid = false;
        }
        // if (dataIngestionMethod === "api" && (numSamples === "" || parseInt(numSamples, 10) <= 0)) {
        //     setNumSamplesError("Please enter a valid number greater than 0.");
        //     isValid = false;
        // }

        return isValid;
    };

    const handleSubmit = async () => {
        const isValid = errorDetect();
        if (!isValid) return;

        let token = Cookies.get("token_xapads_ssp");
        if (!token) return;

        setButtonProcessing(true);

        // try {
        let payload;
        // let headers; // unused - axios call uses inline headers

        // if (dataIngestionMethod === "upload") {
        payload = new FormData();
        payload.append("taskName", name);
        payload.append("platform", platform);
        payload.append("publisherId", publisherList);
        payload.append("zones", JSON.stringify(zoneList));
        payload.append("inventoryType", traffic);
        payload.append("email", jwtDecode(token).email)
        // payload.append("dataIngestionMethod", dataIngestionMethod);
        payload.append("file", uploadedFile);
        // headers = { ... }; // unused - axios call uses inline headers
        // } else {
        //     payload = {
        //         taskName: name,
        //         platform: platform,
        //         publisherId: publisherList,
        //         zones: zoneList,
        //         trafficType: traffic,
        //         dataIngestionMethod: dataIngestionMethod,
        //         numberOfSamples: parseInt(numSamples, 10),
        //         samplingTime: samplingTime,
        //     };
        //     headers = {
        //         "Content-Type": "application/json",
        //         "x-access-token": token,
        //     };
        // }

        //     const response = await axios.post(
        //         configData.SERVER_URL + "healthCenter",
        //         payload,
        //         { headers }
        //     );

        //     notifysuccess(response.data.message || "Task created successfully");
        //     setTimeout(() => {
        //         handlePageViewChange("table", "yes");
        //     }, 1500);
        // } catch (error) {
        //     if (error?.response?.data?.message) {
        //         notifyfailure(error.response.data.message);
        //     } else {
        //         notifycatch();
        //     }
        // } finally {
        //     setButtonProcessing(false);
        // }


        axios
            .post(configData.SERVER_URL + "healthCenter", payload, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "x-access-token": token,

                },
                responseType: "blob",
            },)
            .then(res => {
                // if (res.data.success) {
                //     notifysuccess(res.data.message || "Task created successfully");

                //     const taskId = res.data?.data?.taskId;
                //     if (taskId) {
                //         axios
                //             .get(configData.SERVER_URL + `healthCenter/download?taskId=${taskId}`, {
                //                 headers: { "x-access-token": token },
                //                 responseType: "blob",
                //             })
                //             .then(downloadRes => {
                //                 const blob = new Blob([downloadRes.data], {
                //                     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                //                 });
                //                 const url = window.URL.createObjectURL(blob);
                //                 const anchor = document.createElement("a");
                //                 anchor.href = url;
                //                 anchor.download = `${taskId}.xlsx`;
                //                 document.body.appendChild(anchor);
                //                 anchor.click();
                //                 document.body.removeChild(anchor);
                //                 window.URL.revokeObjectURL(url);
                //             })
                //             .catch(() => {})
                //             .finally(() => {
                //                 handlePageViewChange("table", "yes");
                //                 setButtonProcessing(false);
                //             });
                //     } else {
                //         handlePageViewChange("table", "yes");
                //         setButtonProcessing(false);
                //     }
                // }
                // else {
                //     notifyfailure("Error while creating.");
                //     setButtonProcessing(false);
                // }

                // const contentDisposition = res.headers['content-disposition'];
                let filename = name + '.xlsx';
                // if (contentDisposition) {
                //     const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                //     if (match?.[1]) {
                //         filename = match[1].replace(/['"]/g, '');
                //     }
                // }

                const blob = new Blob([res.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement("a");
                anchor.href = url;
                anchor.download = filename;
                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);
                window.URL.revokeObjectURL(url);

                handlePageViewChange("table", "yes");
                setButtonProcessing(false);

            })
            .catch(async (e) => {
                if (axios.isAxiosError(e) && e.response?.data) {
                    const d = e.response.data;
                    const text =
                        typeof d === "string"
                            ? d
                            : d instanceof Blob
                                ? await d.text()
                                : null;
                    const payload =
                        text != null
                            ? (() => {
                                try {
                                    return JSON.parse(text);
                                } catch {
                                    return null;
                                }
                            })()
                            : d;
                    const errMsg = payload?.error ?? payload?.message ?? e.message;
                    notifyfailure(errMsg)
                }
                else {
                    notifycatch();
                }
                setButtonProcessing(false);
            });
        // }
    };


    return (
        <div className="container_box--wrapper pt_header">
            <div className="container_box--breadcrumb">
                <ul className="container_box--breadcrumb-list">
                    <li>
                        <Link onClick={() => {
                            handlePageViewChange("table", "no")
                        }}>
                            <img src={HealthCenterIcon} alt="USP" /> Health Center
                        </Link>
                    </li>
                    <li className="primary"> New Task</li>
                </ul>
            </div>
            <div className="container_box--wrapper--title">
                <div className="back_btn_d2">
                    <img src={backButton} className="img-fluid" alt=""
                        onClick={() => {
                            handlePageViewChange("table", "no")
                        }}
                    />
                    <h1 className="heading">
                        Configure New Task
                    </h1>
                </div>
            </div>
            <div className="container_box--content pt_20">
                <div className="container_box--width">
                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Task Information</label>
                                <p className="sub_text">Choose Task Name</p>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container">
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group mb_0 hide_caret_after_select_value">
                                            <label className="form_label">Task Name * </label>
                                            <Input className={nameIsRequiredError ? 'form_control basic ' : 'form_control basic'} placeholder='e.g., Daily Adkernel File Analysis' autocomplete="off"
                                                value={name}
                                                onBlur={onBlurName}
                                                onChange={onChangeName}
                                            />
                                            {nameIsRequiredError && (
                                                <span className="error_content">
                                                    This field is required
                                                </span>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div >
                <div className="container_box--width">
                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Analysis Parameters</label>
                                <p className="sub_text">Choose your Parameters</p>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container">
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group hide_caret_after_select_value">
                                            <label className="form_label">Platform * </label>
                                            <Select
                                                className='form_select basic no_search'
                                                placeholder="-Select-"
                                                optionFilterProp="label"
                                                value={platform}
                                                onChange={(event) => { setPlatform(event) }}

                                                options={platformOptions}
                                            />
                                            <span className="error_content"> </span>
                                        </div>
                                        <div className="form_content_block--group  hide_caret_after_select_value">
                                            <label className="form_label">Publisher * </label>
                                            <Select
                                                className={publisherIsRequiredError ? 'form_select basic ' : 'form_select basic '}
                                                showSearch
                                                placeholder="- Select Publisher -"
                                                optionFilterProp="label"
                                                onChange={onChangePublisher}
                                                value={publisherList}
                                                options={publisherListOptions}
                                            />
                                            {publisherIsRequiredError && <span className="error_content">This field is required</span>}
                                        </div>
                                        <div className="form_content_block--group  hide_caret_after_select_value">
                                            <label className="form_label">Inventory Type * </label>
                                            <Select
                                                className='form_select basic no_search'
                                                placeholder="- Select Inventory Type -"
                                                optionFilterProp="label"
                                                onChange={handleTrafficType}
                                                value={traffic}
                                                options={trafficOptions}
                                            />
                                            <span className="error_content"> </span>
                                        </div>
                                        <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                            <div className="form_group form_select_multiple_group">
                                                <label className='form_label'>Zone *</label>
                                                <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100 form_content_block--group mb-0 " >
                                                    {/* <Select
                                                        mode="multiple"
                                                        value={zoneList}
                                                        onChange={setSelected}
                                                        showSearch={false} // ❗ important
                                                        placeholder="Select zone"
                                                        // open={true}
                                                        className="form_select basic no_search"
                                                        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
                                                        style={{ width: "100%" }}
                                                        dropdownRender={() => (
                                                            <>
                                                        
                                                                <div className='custom_inside_searchbar_d2'>
                                                                    <Input
                                                                        placeholder="Search"
                                                                        value={search}
                                                                        onChange={(e) => setSearch(e.target.value)}
                                                                        allowClear
                                                                    />
                                                                </div>

                                                           
                                                                <div className="select_all_d2 select_all_d2" onClick={handleSelectAll}>
                                                                    <Checkbox
                                                                        checked={selected.length === options.length}
                                                                        indeterminate={
                                                                            selected.length > 0 && selected.length < options.length
                                                                        }
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        Select All
                                                                    </Checkbox>
                                                                </div>

                                                             
                                                                {zoneListOptions.map((option) => (
                                                                    <div
                                                                        className='select_all_d2'
                                                                        key={option.value}
                                                                        onClick={() => {
                                                                            if (selected.includes(option.value)) {
                                                                                setSelected(selected.filter((v) => v !== option.value));
                                                                            } else {
                                                                                setSelected([...selected, option.value]);
                                                                            }
                                                                        }}
                                                                    >
                                                                        <Checkbox
                                                                            checked={selected.includes(option.value)}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        >
                                                                            {option.label}
                                                                        </Checkbox>
                                                                    </div>
                                                                ))}
                                                            </>
                                                        )}
                                                    /> */}
                                                    <Select
                                                        value={zoneList}
                                                        popupClassName='diff_select_d2 --padding_remove_cls form_select_multiple--dropdown '
                                                        maxTagCount={2}
                                                        showSearch={false}
                                                        placeholder='- Select Zones -'
                                                        maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
                                                        className="form_select_multiple"
                                                        mode='multiple'
                                                        onChange={(event) => {
                                                            setZoneList(event);
                                                        }}
                                                        open={!!openSelectState[`zone-01`]}
                                                        onDropdownVisibleChange={(open) => toggleSelectOpen(`zone-01`, open)}
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchZoneList} onChange={(e) => {
                                                                        handleSearchZoneList(e)

                                                                    }}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === 'Backspace') {
                                                                                if (searchZoneList.length > 0) {

                                                                                    const input = getRef(`zone-01`).current?.input; // Get input element
                                                                                    const cursorPos = input.selectionStart;; // Get cursor position

                                                                                    if (cursorPos > 0) {
                                                                                        const newValue =
                                                                                            searchZoneList.slice(0, cursorPos - 1) + // Keep text before cursor (excluding deleted char)
                                                                                            searchZoneList.slice(cursorPos); // Keep text after cursor

                                                                                        setSearchZoneList(newValue);
                                                                                        setTimeout(() => {
                                                                                            input.setSelectionRange(cursorPos - 1, cursorPos - 1);
                                                                                        }, 0);
                                                                                    }

                                                                                    e.stopPropagation();
                                                                                    e.preventDefault();


                                                                                } else {

                                                                                    e.stopPropagation();
                                                                                }
                                                                            }
                                                                        }}
                                                                        ref={getRef(`zone-01`)}
                                                                        prefix={<img src={searchIcon} alt="USP" />}
                                                                        allowClear
                                                                        onClear={() => {
                                                                            setSearchZoneList('');
                                                                            setTimeout(() => { getRef(`zone-01`).current?.focus(); }, 0);
                                                                        }} />
                                                                </div>
                                                                {searchZoneList.length === 0 && zoneListOptions?.length > 0 &&
                                                                    <div
                                                                        className={`select_all_d2 ${(zoneList?.length > 0 && zoneList?.length !== zoneListOptions?.length) ? 'intermediate_state' : ''}`}
                                                                        onClick={() => handleSelectAllZoneList()}
                                                                    >

                                                                        <Checkbox
                                                                            checked={zoneList?.length === zoneListOptions?.length}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        >
                                                                            Select All
                                                                        </Checkbox>

                                                                    </div>
                                                                }
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {[
                                                            ...filterZoneList?.filter(option => zoneList?.includes(option.value)), // Checked options first
                                                            ...filterZoneList?.filter(option => !zoneList?.includes(option.value)) // Unchecked options next
                                                        ].map(option => (
                                                            <Option key={option.value} value={option.value}
                                                                className={option.disabled ? "disabled_checkbox_select_2" : ""}
                                                            >
                                                                <div
                                                                    onClick={() => handleZoneList(option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={zoneList?.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        disabled={option.disabled}
                                                                    >
                                                                        <Tooltip title={option.label}>
                                                                            {option.label.length > 38 ? <>{option.label.slice(0, 38)}...</> : <>{option.label}</>}
                                                                        </Tooltip>
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                    {zoneIsRequiredError && <span className="error_content">This field is required</span>}
                                                </div>

                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div >

                <div className="container_box--width">
                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Upload File</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container">
                                <Row gutter={16}>
                                    {/* <Col span={24}>
                                        <div className="form_content_block--group w-100">
                                            <Radio.Group className="form_radio w-100 two_radio_box_design_d2"
                                                value={dataIngestionMethod}
                                                onChange={(event) => { setDataIngestionMethod(event.target.value) }}
                                            >
                                                <Row gutter={16}>
                                                    <Col span={12}>
                                                        <label className="form_label ">
                                                            Choose Method *
                                                        </label>
                                                        <Radio className="radio_btn" value="upload">
                                                            File Upload
                                                        </Radio>
                                                    </Col>

                                                    <Col span={12}>
                                                        <label className="form_label invisible">
                                                            Choose Method *
                                                        </label>
                                                        <Radio className="radio_btn" value="api">
                                                            API
                                                        </Radio>
                                                    </Col>
                                                </Row>
                                            </Radio.Group>
                                        </div>
                                    </Col> */}

                                    {/* {dataIngestionMethod === "upload" ? */}

                                    <Col span={24}>
                                        {/* File Upload  */}
                                        {uploadedFile ?
                                            <>
                                                {/* <div className="d-flex justify_content_between">
                                                    <p className="file_format_name m-0">
                                                        <span>{uploadedFile.name}</span>
                                                        <span
                                                            style={{ fontSize: '12px', marginLeft: '8px', color: '#888' }}
                                                        >
                                                            ({(uploadedFile.size / 1024).toFixed(1)} KB)
                                                        </span>
                                                    </p>
                                                    <button type="link" className="ant_upload_list--delete"
                                                        onClick={() => {
                                                            setUploadedFile(null)
                                                        }}
                                                    >
                                                        <Tooltip title="Delete">
                                                            <img src={deleteIcon} alt="USP" />
                                                        </Tooltip>
                                                    </button>


                                                </div> */}
                                                <label className="form_label_individual">Upload a single Excel file containing sample requests (Adkernel or Publica format)*</label>
                                                <div className="ant_upload_list--item m-0">
                                                    <div className="ant_upload_list--content">
                                                        <img src={XLSXIcon} alt="File" />
                                                        <div className="ant_upload_list--info">
                                                            <span className="ant_upload_list--info-name">{uploadedFile.name}</span>
                                                            <span className='ant_upload_list--info-size'>({(uploadedFile.size / 1024).toFixed(1)} KB)</span>
                                                        </div>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="ant_upload_list--delete"
                                                        onClick={() => {
                                                            setUploadedFile(null)
                                                        }}
                                                    >
                                                        <Tooltip title="Delete">
                                                            <img src={deleteIcon} alt="Remove" />
                                                        </Tooltip>
                                                    </button>
                                                </div>
                                            </>

                                            :
                                            <div className="form_content_block--group mb-0">
                                                <label className="form_label" htmlFor="">Upload a single Excel file containing sample requests (Adkernel or Publica format)*</label>
                                                <label
                                                    htmlFor='fileUploader'
                                                    className={`ant_upload_drag${(fileError || fileIsRequiredError) ? ' error' : ''}`}
                                                    onDragOver={(e) => e.preventDefault()}
                                                    onDrop={handleFileDrop}
                                                >
                                                    <>


                                                        <p className="upload_drag_icon">
                                                            <img src={uploadIcon} alt='USP' />
                                                        </p>


                                                        <p className="ant_upload_text"><b className="primary">Click to upload</b> or drag and drop</p>



                                                        <p style={{ fontSize: '12px', color: '#888', margin: '4px 0 0' }}>Excel file only (.xls, .xlsx) ·
                                                            {/* Max 1 MB */}
                                                        </p>

                                                    </>
                                                </label>
                                                <input
                                                    ref={fileInputRef}
                                                    className='form_upload d-none'
                                                    type="file"
                                                    id="fileUploader"
                                                    name="fileUploader"
                                                    accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                    onChange={handleFileChange}
                                                />
                                                {fileError && <span className="error_content">{fileError}</span>}
                                                {!fileError && fileIsRequiredError && <span className="error_content">This field is required</span>}
                                            </div>
                                        }
                                    </Col>
                                    {/* // :
                                        // <> */}

                                    {/*  Aggregated Reports */}
                                    {/* <Col span={12}>
                                        <div className="form_content_block--group date_picker_d2 mb_0">
                                            <label className="form_label">Select Date Range *</label>

                                            <DateRangePicker
                                                startDate={dateRange.start}
                                                endDate={dateRange.end}
                                                onShow={(event, picker) => {
                                                    picker.container.addClass("hidenextprevnumberscls --remove_text_31days");
                                                }}
                                                initialSettings={{
                                                    autoApply: true,
                                                    locale: { format: "DD/MM/YYYY" },

                                                    // ✅ Restrict to exactly 7 days range
                                                    maxSpan: { days: 6 }, // (start + 6 = 7 days total)

                                                    startDate: dateRange.start.toDate(),
                                                    endDate: dateRange.end.toDate(),

                                                    // optional limits
                                                    minDate: moment("2026-02-01").toDate(),
                                                    maxDate: pstToday.clone().toDate(),
                                                }}
                                                onCallback={(start, end) => {
                                                    const selectedStart = moment(start);
                                                    const selectedEnd = moment(end);

                                                    // ✅ Force 7-day range (safety check)
                                                    const diff = selectedEnd.diff(selectedStart, "days");

                                                    if (diff !== 6) {
                                                        const newEnd = selectedStart.clone().add(6, "days");
                                                        setDateRange({ start: selectedStart, end: newEnd });
                                                    } else {
                                                        setDateRange({ start: selectedStart, end: selectedEnd });
                                                    }
                                                }}
                                            >
                                                <div className="picker-input form_select --daterangepicker --daterangepickerv2 picker_input_value_css">
                                                    {dateRange.start.format("DD MMM YYYY")} -{" "}
                                                    {dateRange.end.format("DD MMM YYYY")}
                                                </div>
                                            </DateRangePicker>

                                        </div>
                                    </Col> */}

                                    {/* API */}
                                    {/* <Col span={12}>
                                                <div className="form_content_block--group mb_0 hide_caret_after_select_value">
                                                    <label className="form_label">Number of Samples *</label>
                                                    <Input
                                                        className={numSamplesError ? 'form_control basic error' : 'form_control basic'}
                                                        placeholder='e.g., 100'
                                                        autoComplete="off"
                                                        value={numSamples}
                                                        onChange={onChangeNumSamples}
                                                        onBlur={onBlurNumSamples}
                                                    />
                                                    {numSamplesError && <span className="error_content">{numSamplesError}</span>}
                                                </div>
                                            </Col>
                                            <Col span={12}>
                                                <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                                    <label className="form_label">Sampling Time (seconds) * </label>
                                                    <Select
                                                        className='form_select basic no_search'
                                                        optionFilterProp="label"
                                                        value={samplingTime}
                                                        onChange={(val) => setSamplingTime(val)}
                                                        options={samplingTimeOptions}
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                            </Col> */}
                                    {/* </> */}
                                    {/* } */}

                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div >

                <div className="hr_custom mb_20"></div>
                <div className="btn_group justify-content-end gap_8 pb_50">
                    {buttonProcessing ?
                        <>
                            <button className="w_120_d2 btn btn_white_outline w_fit_content" disabled>Discard</button>
                            <button className="w_120_d2 btn btn_primary w_fit_content loader">
                                <span>Run</span>
                                <img src={loaderIcon} alt="USP" className="loader_icon" />
                            </button>
                        </>
                        :
                        <>
                            <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={() => { handlePageViewChange("table", "no") }}>Discard</button>
                            <button className="w_120_d2 btn btn_primary w_fit_content" onClick={handleSubmit}>Run</button>
                        </>
                    }

                </div>
            </div >
        </div>
    )
}

export default CreateNewTask
